import type {
  CrossroadsLog,
  GroupMetadata,
} from '@/api/hooks/useIntegrationLogs'
import { LegacyLogDetailsPanel } from './LegacyLogDetailsPanel'
import { V3LogDetailsPanel } from './V3LogDetailsPanel'
import { isV3Detail } from './categories'

export type LogDetailsPanelProps = {
  log: CrossroadsLog | null
  groupMetadata?: GroupMetadata | null
}

/** Routes a log to the panel that understands its detail type. V3 details
 * (and successes) get the new panel; everything else keeps the legacy one so
 * historical logs still render. */
export function LogDetailsPanel({ log, groupMetadata }: LogDetailsPanelProps) {
  if (!log) return null

  if (isV3Detail(log.detail)) {
    return (
      <V3LogDetailsPanel
        log={log}
        detail={log.detail}
        groupMetadata={groupMetadata}
      />
    )
  }

  return <LegacyLogDetailsPanel log={log} groupMetadata={groupMetadata} />
}
